import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import React from "react";

const ImageThumbnail = ({ image, isSelected, onClick }) => {
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    setLoaded(false);
  }, [image?.Id, image?.FullImageUrl, image?.ThumbnailUrl]);

  const tileStyle = isSelected
    ? "imagefolder__image-tile--selected"
    : "imagefolder__image-tile";

  const isVideo = image.MimeType && image.MimeType.startsWith("video/");
  // Use the best available URL as the video source; thumbnail URL may itself be the video file.
  const videoSourceUrl =
    image.FullImageUrl ||
    image.S3FullImageUrl ||
    image.ThumbnailUrl ||
    image.S3ThumbnailUrl;

  return (
    <div className={tileStyle} onClick={() => onClick(image.Id)}>
      <button
        className="pedag-doc-img-folder-thumbnail"
        style={{ position: "relative" }}
      >
        {!loaded && (
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1,
            }}
          >
            <CircularProgress size={24} />
          </Box>
        )}
        {isVideo ? (
          <video
            src={videoSourceUrl}
            muted
            preload="metadata"
            playsInline
            onLoadedMetadata={(e) => {
              // Seek to first frame — do NOT reveal yet, wait for onSeeked.
              try {
                e.target.currentTime = 0.001;
              } catch (_) {
                setLoaded(true);
              }
            }}
            onSeeked={() => setLoaded(true)}
            onError={() => setLoaded(true)}
            style={{
              opacity: loaded ? 1 : 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              pointerEvents: "none",
            }}
          />
        ) : (
          <img
            src={image.ThumbnailUrl}
            alt="ImageThumbnail"
            loading="lazy"
            decoding="async"
            onLoad={() => setLoaded(true)}
            onError={() => setLoaded(true)}
            style={{ opacity: loaded ? 1 : 0 }}
          />
        )}
        {isVideo && loaded && (
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              pointerEvents: "none",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="36"
              height="36"
              viewBox="0 0 24 24"
              fill="rgba(255,255,255,0.9)"
              style={{ filter: "drop-shadow(0 1px 4px rgba(0,0,0,0.6))" }}
            >
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z" />
            </svg>
          </Box>
        )}
      </button>
      {image.Header && (
        <div className="pedag-doc-img-folder-thumbnail__header">
          {image.Header}
        </div>
      )}
    </div>
  );
};
export default ImageThumbnail;
